/* eslint-disable */
import _ from 'lodash';

const getters = {
  rolePermissions: (state) => state.rolePermissions,
  rolesList: (state) => Object.keys(state.rolePermissions),
  roleHasPermission: (state) => ({ role, permission }) => {
    return _.get(state, `rolePermissions.${role}.${permission}`, false);
  },
  currentUserHasPermission: (state, _getters, rootState, rootGetters) => (permission) => {
    console.log(rootGetters)
    const role = rootGetters['auth/currentUserRole'];
    return getters.roleHasPermission(state)({ role, permission });
  },
  canViewIntranetControlTab: (state, _g, _r, rootGetters) => getters.currentUserHasPermission(state, _g, _r, rootGetters)('viewIntranetControlTab'),
  canViewSynchronizationTab: (state, _g, _r, rootGetters) => getters.currentUserHasPermission(state, _g, _r, rootGetters)('viewSynchronizationTab'),
  canViewApplicationControlTab: (state, _g, _r, rootGetters) => getters.currentUserHasPermission(state, _g, _r, rootGetters)('viewApplicationControlTab'),
};

export default getters;
